import {
  getAuth,
  signInWithPhoneNumber,
  updateProfile,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import React, { useState } from "react";
import { useRef } from "react";
import { toast } from "react-toastify";
import { AuthErrorMessages } from "../../../controllers/auth/AuthErrorMessages";
import { CreateBusinessRecord } from "../../../controllers/auth/CreateBusinessRecord";
import { CreateUserRecord } from "../../../controllers/auth/CreateUserRecord";
import isUserExists from "../../../controllers/auth/isUserExists";
import PostRegister from "../../../controllers/auth/PostRegister";
import SeedBusinessRecord from "../../../controllers/auth/SeedBusinessRecord";
import SeedUserRole from "../../../controllers/auth/SeedUserRole";
import { createSubCollectionInClient } from "../../../controllers/dynamicFields/createSubCollectionInClient";
import { getCompleteCollection } from "../../../controllers/dynamicFields/getCompleteCollection";
import { db, functions } from "../../../firebase";

let UserName = "";
let PhoneNumber = "";
let Email = "";
let Business = "";

export default function useRegister() {
  let auth = getAuth();
  const [AuthState, setAuthState] = useState("email");
  const [ButtonLoader, setButtonLoader] = useState(false);
  const [CodeSent, setCodeSent] = useState(false);
  const [Error, setError] = useState(false);
  const [PhoneFormDisabled, setPhoneFormDisabled] = useState(false);

  const RegisterButtonRef = useRef();

  const RegisterUsingEmail = (e) => {
    const { name, email, phone, password, business } = e;

    const registerUser = httpsCallable(functions, "registerUser");

    return registerUser(e)
      .then(async ({ data: userCredential }) => {
        if (typeof userCredential === "string") throw userCredential;

        return await signInWithEmailAndPassword(
          getAuth(),
          email,
          password
        ).then(async (cred) => {
          const {
            user: { phoneNumber },
          } = cred;

          const invited = await collection(db, "invited-agents");

          const q = await query(invited, where("number", "==", phoneNumber));

          const _docs = await getDocs(q);

          let e;
          if (_docs.docs.length === 0) {
            e = {
              name,
              email,
              phone,
              password,
              business,
            };
          } else {
            const { agentName, email, bid, aid } = await _docs.docs[0].data();
            e = {
              name: agentName,
              email: email,
              phone: phoneNumber,
              password: "",
              business: null,
              bid,
              aid,
              role: "agent",
            };
          }

          await PostRegister(cred, e, {
            profile: {
              ...cred.user,
            },
            providerId: "password",
            isNewUser: true,
          });
        });
      })
      .catch((error) => {
        console.log(error);
        AuthErrorMessages(error);
        return false;
      });
  };

  const TerminateAuth = () => {
    toast.error("User already exists!", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setPhoneFormDisabled(false);
  };

  const RegisterUsingPhoneNumber = async (e) => {
    setPhoneFormDisabled(true);
    const { name, phone, business } = e;
    if (await isUserExists("phone", phone)) return TerminateAuth();

    UserName = name;
    PhoneNumber = phone;
    Business = business;
    signInWithPhoneNumber(auth, phone, window.recaptchaVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;

        setCodeSent(true);
        setButtonLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const UpdateUserName = async () => {
    const updateUserName = httpsCallable(functions, "updateUserName");
    let updatedData = {
      uid: getAuth().currentUser.uid,
      name: UserName,
    };
    if ((await updateUserName(updatedData)) === true) {
      await updateProfile(getAuth().currentUser, { displayName: UserName });
      await getAuth().currentUser.updateProfile({ displayName: UserName });
      return await getAuth()
        .currentUser.reload()
        .then(() => true)
        .catch(() => false);
    } else {
      // ...error
    }
  };

  const VerifyCode = async (code) => {
    try {
      setButtonLoader(true);

      return await window.confirmationResult
        .confirm(code)
        .then(async (snapshot) => {
          const { uid } = getAuth().currentUser;

          await UpdateUserName();

          const record = {
            uid,
            name: UserName,
            email: Email,
            business: Business,
            phoneNumber: PhoneNumber,
          };
          await CreateUserRecord(record, {
            profile: {
              name: UserName,
              email: "",
              verification_email_sent: true,
            },
            providerId: "phone",
          });

          // Creating Business Record
          await CreateBusinessRecord(record, {});
          await SeedBusinessRecord(uid);
          await SeedUserRole(uid);
          await createSubCollectionInClient(await getCompleteCollection());

          setButtonLoader(true);
          setError(false);
          return true;
        })
        .catch((error) => {
          AuthErrorMessages("auth/captcha-expired");
          console.log(error);
          setButtonLoader(false);
          setError(true);
          return false;
        });
      // console.log(result);
      // return true;
    } catch (error) {
      setButtonLoader(false);
      setError(true);
      return false;
    }
  };

  const goBack = () => {
    setButtonLoader(false);
    setCodeSent(false);
    setError(false);
    setPhoneFormDisabled(false);
  };

  return [
    AuthState,
    setAuthState,
    RegisterUsingPhoneNumber,
    PhoneFormDisabled,
    RegisterButtonRef,
    CodeSent,
    setCodeSent,
    VerifyCode,
    Error,
    setError,
    ButtonLoader,
    goBack,
    RegisterUsingEmail,
  ];
}
